import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { AgGridModule } from "ag-grid-angular";
import { NgxSpinnerModule } from "ngx-spinner";
import { BadgeModule } from "primeng/badge";
import { BreadcrumbModule } from "primeng/breadcrumb";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { InputTextModule } from "primeng/inputtext";
import { InputTextareaModule } from "primeng/inputtextarea";
import { PasswordModule } from "primeng/password";
import { SplitterModule } from "primeng/splitter";
import { TableModule } from "primeng/table";
import { ToastModule } from "primeng/toast";
import { ToolbarModule } from "primeng/toolbar";
import { TooltipModule } from "primeng/tooltip";
import { AuthGuardService } from "../services/auth-guard.service";
import { AccessSettingActionComponent } from "./access-setting-action.component";
import { AddUserComponent } from "./add-user.component";
import { ImportRosterComponent } from "./import-roster.component";
import { ManageUserComponent } from "./manage-user.component";
import { OperationAccessSettingActionComponent } from "./operation-access-setting-action.component";
import { ProjectColumnAccessSettingComponent } from "./project-column-access-setting.component";
import { ResetPasswordComponent } from "./reset-password.component";
import { RoleFormComponent } from "./role-form.component";
import { RoleOperationManagementComponent } from "./role-operation-management.component";
import { UserProfileComponent } from "./user-profile.component";
import { UserRoleManagementComponent } from "./user-role-management.component";
import { UserSelectionFormComponent } from "./user-selection-form.component";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgxSpinnerModule,
    AgGridModule.withComponents([]),

    BadgeModule,
    BreadcrumbModule,
    ButtonModule, 
    CardModule,
    ConfirmDialogModule,
    InputTextModule,
    InputTextareaModule,
    PasswordModule,
    SplitterModule,
    TableModule,
    ToastModule,
    ToolbarModule,
    TooltipModule,
    
    RouterModule.forChild([
      { path: 'add-user', component: AddUserComponent, canActivate: [AuthGuardService] },
      { path: 'manage-user', component: ManageUserComponent, canActivate: [AuthGuardService] },
      { path: 'project-column-access-setting', component: ProjectColumnAccessSettingComponent, canActivate: [AuthGuardService] },
      { path: 'reset-password', component: ResetPasswordComponent, canActivate: [AuthGuardService] },
      { path: 'role-operation-management', component: RoleOperationManagementComponent, canActivate: [AuthGuardService] },
      { path: 'user-role-management', component: UserRoleManagementComponent, canActivate: [AuthGuardService] },
      { path: 'user-profile', component: UserProfileComponent, canActivate: [AuthGuardService] },
      { path: 'import-roster', component: ImportRosterComponent, canActivate: [AuthGuardService] }
    ])    
  ],
  declarations: [
    AddUserComponent,
    AccessSettingActionComponent,
    ManageUserComponent,
    OperationAccessSettingActionComponent,
    ProjectColumnAccessSettingComponent,
    ResetPasswordComponent,
    RoleFormComponent,
    RoleOperationManagementComponent,
    UserProfileComponent,
    UserRoleManagementComponent,
    UserSelectionFormComponent,
    ImportRosterComponent
  ]
})
export class AdminModule{}